import {
  ApiOutlined,
  BranchesOutlined,
  CalculatorOutlined,
  ControlOutlined,
  FlagOutlined,
  ForkOutlined,
  MergeCellsOutlined,
  PartitionOutlined,
  UserOutlined,
} from '@ant-design/icons';

/** Four-point "spark" for AI primitives — a deliberate, non-emoji mark distinct from all others. */
const spark = (
  <svg width={12} height={12} viewBox="0 0 16 16" aria-hidden focusable="false">
    <path
      d="M8 0.5c.4 3.2 1.9 4.6 5.5 5.5-3.6.9-5.1 2.3-5.5 5.5-.4-3.2-1.9-4.6-5.5-5.5C6.1 5.1 7.6 3.7 8 .5Z"
      fill="currentColor"
    />
  </svg>
);

/** Resolves a NODE_KIND_META glyph token to a renderable icon. Pure factory — no component exports. */
export function resolveGlyph(token: string): React.ReactNode {
  switch (token) {
    case 'api':
      return <ApiOutlined />;
    case 'branch':
      return <BranchesOutlined />;
    case 'split':
      return <ForkOutlined />;
    case 'merge':
      return <MergeCellsOutlined />;
    case 'user':
      return <UserOutlined />;
    case 'partition':
      return <PartitionOutlined />;
    case 'scoring':
      return <CalculatorOutlined />;
    case 'flag':
      return <FlagOutlined />;
    case 'gate':
      return <ControlOutlined />;
    case 'spark':
      return spark;
    default:
      return <ApiOutlined />;
  }
}
